import React from 'react';
import { motion, useReducedMotion } from 'framer-motion';
import './PartnersStrip.css';

const PARTNERS = [
  { name: 'OpenTable', src: '/partners/opentable.png' },
  { name: 'Clover', src: '/partners/clover.png' },
  { name: 'Square', src: '/partners/square.png' },
  { name: 'Stripe', src: '/partners/stripe.png' }
];

function PartnersStrip() {
  const reduce = useReducedMotion();
  return (
    <section className="vpart" aria-label="Works with the tools you already use">
      <motion.p
        className="vpart-label"
        initial={reduce ? false : { opacity: 0, y: 14 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.6 }}
        transition={{ duration: 0.5, ease: [0.22, 0.61, 0.36, 1] }}
      >
        Works with the tools you already use
      </motion.p>
      <motion.ul
        className="vpart-logos"
        initial={reduce ? false : { opacity: 0, y: 14 }}
        whileInView={{ opacity: 1, y: 0 }}
        viewport={{ once: true, amount: 0.4 }}
        transition={{ duration: 0.55, delay: 0.1, ease: [0.22, 0.61, 0.36, 1] }}
      >
        {PARTNERS.map((p) => (
          <li key={p.name}>
            <img src={p.src} alt={p.name} loading="lazy" draggable="false" />
          </li>
        ))}
      </motion.ul>
    </section>
  );
}

export default PartnersStrip;
